import uniq from 'lodash/uniq';

import {
  SCHEMA_INIT,
  SCHEMA_ADD,
  SCHEMA_REMOVE,
  SCHEMA_UPDATE,
  SCHEMA_ADD_BATCH,
  SCHEMA_ADD_LISTING,
  SCHEMA_REMOVE_BATCH,
  SCHEMA_ADD_PLACE_LISTINGS,
  SCHEMA_REMOVE_PLACES_THEMES,
} from '../actions/types';

const init = () => ({ byId: {}, allIds: [] });

const INITIALSTATE = {
  treks: init(),
  lodges: init(),
  reviews: init(),
  comments: init(),
  days: init(),
  myTreks: init(),
  places: init(),
  sightings: init(),
  attractions: init(),
  sidetrips: init(),
  flights: init(),
  users: init(),
  lodgeDetail: init(),
  guides: null,
  placesList: { byName: {}, allNames: [] },
};

export default (state = INITIALSTATE, action) => {
  const { schema, data } = action.payload || {};

  switch (action.type) {
    case SCHEMA_INIT:
      return {
        ...state,
        [schema]: {
          byId: data,
          allIds: Object.keys(data),
        },
      };

    case SCHEMA_ADD:
      return {
        ...state,
        [schema]: {
          byId: {
            ...state[schema].byId,
            [data.id]: data,
          },
          allIds: uniq(state[schema].allIds.concat(data.id)),
        },
      };

    case SCHEMA_ADD_BATCH:
      return {
        ...state,
        [schema]: {
          byId: {
            ...state[schema].byId,
            ...data,
          },
          allIds: Object.keys({ ...state[schema].byId, ...data }),
        },
      };

    case SCHEMA_REMOVE:
      return {
        ...state,
        [schema]: {
          byId: Object.keys(state[schema].byId).reduce((res, b) => {
            if (b.id !== data.id) {
              return Object.assign(res, { [b.id]: b });
            }
            return res;
          }, {}),
          allIds: state[schema].allIds.filter(id => id !== data.id),
        },
      };

    case SCHEMA_UPDATE:
      return {
        ...state,
        [schema]: {
          byId: {
            ...state[schema].byId,
            [data.id]: {
              ...state[schema].byId[data.id],
              ...data,
            },
          },
          allIds: state[schema].allIds,
        },
      };

    case SCHEMA_REMOVE_BATCH:
      return {
        ...state,
        [schema]: {
          byId: {},
          allIds: [],
        },
      };
    case SCHEMA_REMOVE_PLACES_THEMES:
      return {
        ...state,
        [schema]: {
          byId: {
            ...state[schema].byId,
            [action.payload.placeId]: {
              ...state[schema].byId[action.payload.placeId],
              [action.payload.theme]: [],
            },
          },
          allIds: state[schema].allIds,
        },
      };

    case SCHEMA_ADD_LISTING:
      return { ...state, [schema]: data };

    case SCHEMA_ADD_PLACE_LISTINGS:
      return {
        ...state,
        placesList: {
          byName: {
            ...state.placesList.byName,
            [action.payload.region]: data,
          },
          allNames: uniq(state.placesList.allNames.concat(action.payload.region)),
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/schemaReducer.js